import React from 'react';
import { I18n } from 'js/components/common/I18n';
import { usePortletTranslations } from 'js/components/system/Portlet';

import style from './index.scss';

export const Info = ({ cellphone = '' }) => {
    const t = usePortletTranslations();
    const tKey = cellphone ? 'success' : 'notification';
    const icon = cellphone ? style.iconSuccess : style.iconNotify;

    return (
        <div className={`${style.container} ${style.containerInfo}`}>
            <div className={`${style.icon} ${icon}`} />
            <div className={style.message}>
                <I18n t={t} tKey={tKey} />
            </div>
        </div>
    );
};

export default Info;
